import React, { useState, useRef } from 'react';
import './Brands.css';

// Import brand images
import AITOPhilippinesLogo from '../images/Brands/Aito.png';
import BeijingFootSpaLogo from '../images/Brands/BeijingFootSpa.jpg';
import DestiliriaBarakoLogo from '../images/Brands/DestiliriaBarako.png';
import ElChatoLogo from '../images/Brands/ElChato.png';
import TupperwareLogo from '../images/Brands/Tupperware.png';
import WilliamBrothersLogo from '../images/Brands/WilliamBrothers.png';

const Brands  = () => {
  const [hoveredBrand, setHoveredBrand] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0, side: 'right' });
  const containerRef = useRef(null);

  // Brand data with testimonials
  const brands = [
    
    {
      id: 'beijing-foot-spa',
      name: 'Beijing Foot Spa',
      logo: BeijingFootSpaLogo,
      testimonial: {
        text: "Working with Hunter Digital Marketing Solutions has been such a smooth and positive experience. We've seen a noticeable increase in brand awareness, and more clients now recognize and engage with us online. One of our previously low-performing branches has even experienced growth in client visits, which we attribute in part to the improved online presence.",
        author: "Beijing Foot Spa Team",
        position: "Management"
      }
    },
    
    {
      id: 'william-brothers',
      name: 'William Brothers Manila',
      logo: WilliamBrothersLogo,
      testimonial: {
        text: "We started working with Hunter Digital a few months ago to manage our social media campaigns on Facebook and Instagram, and we couldn't be happier with the results! The results speak for themselves: just days after launching one of their campaigns, we closed a project with a client who discovered us through their work. In an industry where closing deals often takes weeks or even months, this was a game-changer for us!",
        author: "William Brothers Team",
        position: "Manila Office"
      }
    }
  ];

  const handleMouseEnter = (brand, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    
    // Calculate center of the brand item
    const brandCenterX = rect.left + rect.width / 2;
    const brandCenterY = rect.top + rect.height / 2;
    
    // Popup dimensions (approximate)
    const popupWidth = 420;
    const popupHeight = 300;
    const spacing = 20; // spacing from brand item
    
    // Determine which side has more space
    const spaceOnRight = viewportWidth - rect.right;
    const spaceOnLeft = rect.left;
    
    let x, y, side;
    
    // Choose side based on available space
    if (spaceOnRight >= popupWidth + spacing) {
      // Position to the right
      side = 'right';
      x = rect.right + spacing;
    } else if (spaceOnLeft >= popupWidth + spacing) {
      // Position to the left
      side = 'left';
      x = rect.left - popupWidth - spacing;
    } else {
      // Default to right if both sides are cramped
      side = 'right';
      x = Math.min(rect.right + spacing, viewportWidth - popupWidth - 20);
    }
    
    // Center vertically relative to the brand item CENTER (not bottom)
    y = brandCenterY - popupHeight / 2;
    
    // Ensure popup doesn't go off-screen vertically
    const minY = 20;
    const maxY = window.innerHeight - popupHeight - 20;
    y = Math.max(minY, Math.min(y, maxY));
    
    setHoveredBrand(brand);
    setPopupPosition({ x, y, side, brandCenterY });
  };

  const handleMouseLeave = () => {
    setHoveredBrand(null);
  };

  return (
    <>
      {/* Full-screen overlay */}
      {hoveredBrand && <div className="full-screen-overlay" />}
      
      <section className={`testimonials ${hoveredBrand ? 'dimmed' : ''}`} id="testimonials" ref={containerRef}>
        <div className="container">
        <h2 className="section-title">Some Of The Brands We Hunted For</h2>
        
        <div className="brands-grid">
          {brands.map((brand) => (
            <div
              key={brand.id}
              className={`brand-item ${hoveredBrand?.id === brand.id ? 'active' : ''}`}
              onMouseEnter={(e) => handleMouseEnter(brand, e)}
              onMouseLeave={handleMouseLeave}
            >
              <img 
                src={brand.logo} 
                alt={brand.name}
                className="brand-logo"
              />
            </div>
          ))}
        </div>

        {/* Testimonial Popup */}
        {hoveredBrand && (
          <div 
            className={`testimonial-popup ${popupPosition.side}`}
            style={{
              left: popupPosition.x,
              top: popupPosition.y,
              '--brand-center-y': `${popupPosition.brandCenterY}px`,
              '--popup-top': `${popupPosition.y}px`
            }}
          >
            <div className="popup-content">
              <div className="quote-icon">"</div>
              <p className="popup-text">
                {hoveredBrand.testimonial.text}
              </p>
              <div className="popup-author">
                <div className="author-avatar">
                  {hoveredBrand.testimonial.author.charAt(0)}
                </div>
                <div className="author-info">
                  <h4>{hoveredBrand.testimonial.author}</h4>
                  <p>{hoveredBrand.testimonial.position}</p>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </section>
    </>
  );
};

export default Brands;
